<template>
    <footer>
        <b-container fluid="sm">
            <div class="text-center">
                <router-link to="/">{{name}}社区</router-link>
                <p>人工智能时代，学习编程，培养小朋友想象力、创造力、逻辑思维能力</p>
                <a class="bei-an" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2020101903号-1</a>
            </div>
        </b-container>
    </footer>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "Foot",
        computed: {
            ...mapGetters(['name'])
        }
    }
</script>

<style lang="scss" scoped>
    footer {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 190px;
        padding: 40px;
        width: 100%;
        background: #f6f6f6 url("https://static.makerfac.com/img/footerbg.png") no-repeat top center;
        background-size: cover;
        color: white;
        overflow: hidden;

        a {
            color: white;
            text-decoration: none;
            font-size: 25px;
            font-weight: bold;
            margin-bottom: 16px;
            text-shadow: 2px 2px 2px rgba(0, 0, 0, .2);
        }

        p {
            font-size: 12px;
            line-height: 40px;
        }

        .bei-an {
            font-size: 10px;
            font-weight: normal;
        }
    }
</style>
